module.exports = __webpack_public_path__ + "img/MSE.0e980c0b.png";